import actions from '../../snapit_app/actions';
import session_actions from '../actions'
//import User from '../../common/models/user';
import { Map } from 'immutable';

const DEFAULT_STATE = new Map({changing_category: false, logging_in:false, syncing_item_props: false, deleting_an_item:false});

// This reducer is responsible for tracking the identity of the user
function UserReducer(state = DEFAULT_STATE, action) {
  switch (action.type) {
  case session_actions.LOGOUT:
    return DEFAULT_STATE;

  case actions.CODE_LOGIN_FORM_SUBMITTING:
  case actions.LOGIN_FORM_SUBMITTING:
    return state.merge({logging_in: true})
  case actions.CODE_LOGIN_FORM_FAILURE:
  case actions.LOGIN_FORM_FAILURE:
    return state.merge({logging_in: false})
  case actions.SYNCING_ITEM_PROPS:
    return state.merge({syncing_item_props: true})
  case actions.SYNC_ITEM_PROPS_SUCCESS:
  case actions.SYNC_ITEM_PROPS_FAILURE:
    return state.merge({syncing_item_props: false})
  case actions.DELETING_ITEM:
    return state.merge({deleting_an_item: true})
  case actions.DELETE_ITEM_SUCCESS:
  case actions.DELETE_ITEM_FAILURE:
    return state.merge({deleting_an_item: false})
  case actions.SET_CHANGING_CATEGORY:
    return state.merge({changing_category:action.true_or_false})
  case actions.CODE_LOGIN_FORM_SUCCESS:
    return new Map(action.response.entities.users[action.response.result.user]);
  case actions.LOGIN_FORM_SUCCESS:
    return new Map(action.response.entities.users[action.response.result.user]);
  default:
    if (action.response && action.response.entities && action.response.entities.users && action.response.entities.users[state.uid]){
      return new Map(action.response.entities.users[state.uid])
    }else{
      return state;
    }
  }
}

export default UserReducer;



// WEBPACK FOOTER //
// ./src/session/reducers/user.js